/**
 * Project: academy-v2
 * File: ReadingExercise
 * Author: wanpeninsula
 * Author URI: https://www.pennycodes.dev
 * Created: 30/01/2024 at 5:48 am
 *
 * Copyright (c) 2024 academy-v2. All rights reserved.
 */

import { SpinnerLoader } from "@/components/ui/Loader.tsx";
// import AnswerSheet from "@/components/v3/exercises/AnswerSheet";
import { ExerciseType } from "@/components/v3/exercises/ExerciseBadge";
import ReadingAnswerSheet from "@/components/v3/exercises/ReadingAnswerSheet";
// import { useMore } from "@/contexts/MoreContext";
import { useUserExercises } from "@/data/exercises.ts";
import ExerciseLayout from "@/layouts/ExerciseLayout.tsx";
import { useNavigate, useParams } from "react-router-dom";

function ReadingExercise() {
  const { id } = useParams();
  // const { isBeta } = useMore();
  const { exercises, isLoading } = useUserExercises();
  const exercise = exercises?.toDo.find((e) => e.token == id);
  const navigate = useNavigate();

  return (
    <ExerciseLayout
      type={ExerciseType.READING}
      title={exercise?.name}
      exercise={exercise}
      onClose={() => navigate(-1)}
    >
      {isLoading ? (
        <div className="flex items-center justify-center w-full h-full">
          <SpinnerLoader className={"!h-12 !w-12 border-t-light"} />
        </div>
      ) : (
        // isBeta ? (
          <ReadingAnswerSheet exercise={exercise} id={exercise?.id as number} />
        // ) : (
        //   <AnswerSheet exercise={exercise} id={exercise?.id as number} />
        // )
      )}
    </ExerciseLayout>
  );
}

export default ReadingExercise;
